import { EpimsBaseEntityDto } from './epim-base.dto';

export class CorrespondenceDepartmentFunctionDto extends EpimsBaseEntityDto {
  CorrespondenceDepartmentFunctionName: string;
  CompanyId: string;
}
